import React from 'react'
import Layout from "../components/layout/layout"
import SEO from "../components/seo"
import { graphql } from "gatsby"
import BetterHero from '../components/betterhero'
import BWCarousel from '../components/bwcarousel.js'
import BetterScrolls from '../components/betterscrolls'
import ReactMarkdown from 'react-markdown'
import BetterAction from '../components/betteraction'


export default ({data}) => {
    const {
        allStrapiBetterHeroes:{nodes:hero},
        allStrapiBetterScrolls:{nodes:scrolls},
        allStrapiBetterFeatureHeader:{nodes:featureheader},
        allStrapiBetterFeatures:{nodes:features},
        allStrapiBetterActions:{nodes:actions},
    } = data //destructure the data

    const{ fheading , fbody  } = featureheader[0]

    return (
        <Layout>
          <SEO title={hero[0].SEOtitle} description={hero[0].SEOdescription}/>
          <main>
            {/* start hero section */}
            <section class="block overflow-hidden box-border w-full bg-gradient-to-tl from-sc-primary-blue to-white">
                {/* load hero component */}
                <BetterHero hero={hero} usertype="customer"/>
                { /* <!--SVG Base (wave)--> */}
                <div class="relative -mt-4 scmd:-mt-20 pointer-events-none">
                    <svg viewBox="0 0 1428 174" version="1.1" xmlns="http://www.w3.org/2000/svg" >
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g transform="translate(-2.000000, 44.000000)" fill="#FFFFFF" fill-rule="nonzero">
                                <path d="M0,0 C90.7283404,0.927527913 147.912752,27.187927 291.910178,59.9119003 C387.908462,81.7278826 543.605069,89.334785 759,82.7326078 C469.336065,156.254352 216.336065,153.6679 0,74.9732496" opacity="0.100000001"></path>
                                <path d="M100,104.708498 C277.413333,72.2345949 426.147877,52.5246657 546.203633,45.5787101 C666.259389,38.6327546 810.524845,41.7979068 979,55.0741668 C931.069965,56.122511 810.303266,74.8455141 616.699903,111.243176 C423.096539,147.640838 250.863238,145.462612 100,104.708498 Z" opacity="0.100000001"></path>
                                <path d="M1046,51.6521276 C1130.83045,29.328812 1279.08318,17.607883 1439,40.1656806 L1439,120 C1271.17211,77.9435312 1140.17211,55.1609071 1046,51.6521276 Z" id="Path-4" opacity="0.200000003"></path>
                            </g>
                            <g transform="translate(-4.000000, 76.000000)" fill="#FFFFFF" fill-rule="nonzero">
                                <path d="M0.457,34.035 C57.086,53.198 98.208,65.809 123.822,71.865 C181.454,85.495 234.295,90.29 272.033,93.459 C311.355,96.759 396.635,95.801 461.025,91.663 C486.76,90.01 518.727,86.372 556.926,80.752 C595.747,74.596 622.372,70.008 636.799,66.991 C663.913,61.324 712.501,49.503 727.605,46.128 C780.47,34.317 818.839,22.532 856.324,15.904 C922.689,4.169 955.676,2.522 1011.185,0.432 C1060.705,1.477 1097.39,3.129 1121.236,5.387 C1161.703,9.219 1208.621,17.821 1235.4,22.304 C1285.855,30.748 1354.351,47.432 1440.886,72.354 L1441.191,104.352 L1.121,104.031 L0.457,34.035 Z"></path>
                            </g>
                        </g>
                    </svg>     
                </div>
            </section>
            {/* end hero section */}

            {/* start better scrolls section */}
            <BetterScrolls scrolls={scrolls} usertype="customer"/>
            {/* end better scrolls section */}

            {/* start upcoming platform features section header */}  
            <section class="block box-border w-full pt-16 scmd:pt-24">
                <div class="scxl:max-w-7xl mx-auto my-0 relative py-0 px-4">
                    <div class="flex flex-wrap w-full content-center">
                        <div class="w-11/12 scmd:w-1/2 m-auto flex-grow-0 flex-shrink-0 text-gray-600 text-center">
                            <h3 class="mt-5 mb-2.5">{fheading}</h3>
                            <p class="mb-9">
                                <ReactMarkdown source={fbody} />
                            </p>
                        </div>
                    </div>
                </div>
                {/* start features carousel */}
                <div class="features-swiper w-full pt-2 p-4 scmd:p-0">
                    <div class="my-0 py-0 mb-4">
                        {/* load features carousel */}
                        <BWCarousel features={features} usertype="customer"/>
                    </div>
                </div>
                  {/* end features carousel */}
            </section>
            {/* end upcoming platform features section header */}      

            {/* start registration call to action in this section */}
            <section class="block box-border w-full pt-16 scmd:pt-24 mb-16 scmd:mb-24 ">
              <BetterAction actions={actions} usertype="customer"/>
            </section>
            {/* end registration call to action in this section */}
          </main>
        </Layout>
    )
}


export const query = graphql`
  {
    allStrapiBetterHeroes(filter: {usertype: {eq: "customer"}}) {
    nodes {
      altText
      SEOdescription
      SEOtitle
      heading
      body
      usertype
      image {
        childImageSharp {
          fluid(maxWidth: 2048, quality: 64) {
              ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  }
  allStrapiBetterScrolls(filter: {usertype: {eq: "customer"}}, sort: {order: ASC, fields: rank}) {
    nodes {
      rank
      heading
      body
      usertype
      video {
        publicURL
      }
      videoposter {
        publicURL
      }
    }
  }
  allStrapiBetterFeatureHeader {
    nodes {
      fheading: heading
      fbody: body
    }
  }
  allStrapiBetterFeatures(filter: {usertype: {elemMatch: {title: {eq: "customer"}}}}, sort: {fields: rank, order: ASC}) {
    nodes {
      altText
      heading
      body
      rank
      image {
        childImageSharp {
          fluid(maxWidth: 2048, quality: 64) {
              ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  }
  allStrapiBetterActions(filter: {usertype: {eq: "customer"}}) {
    nodes {
      altText
      heading
      subheading
      title
      body
      buttontext
      image {
        childImageSharp {
          fluid(maxWidth: 2048, quality: 64) {
              ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  }
}
`

